import { render, staticRenderFns } from "./SavedAlert.vue?vue&type=template&id=254a6de0&"
import script from "./SavedAlert.vue?vue&type=script&lang=js&"
export * from "./SavedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports